import router from "./router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";

NProgress.configure({ showSpinner: false });

const whiteList = [
  "/index",
  "/login",
  "/register",
  "/findbackstep",
  "/index",
  "/bookstore/index",
  "/bookstore/bookstoreDetail",
  "/special/index",
  "/special/specialDetail",
  "/authorLibrary/index",
  "/authorLibrary/authorDetail",
  "/coagency/index",
  "/coagency/coagencyDetail",
  "/mobileterminalread",
  "/search/index",
  "/download",
  "/app/read",
  "/download/app",
  "/app/resourceList",
  "/lxdownload",
  "/lxexplain",
  "/lxvideo",
  "/news/newsDetail",
  "/kefu",
  "/resourcesRead",
  "/willingLearn/index/index",
  "/willingLearn/bookstoreDetail",
  "/willingLearn/bookstore",
  "/textBookReader",
  "/resourcesRead_v2",
  "/booksRead",
  "/examination",
  "/Lib/gx",
  "/huiLearning",
  "/app/newsDetail",
  "/textBookReader_v2",
  "/IntegratedLogin",
  "/textBooksRead",
  "/booksRead-mobile",
  "/general",
];
const authUseList = ["/login", "/register", "/findbackstep"];

router.beforeEach(async (to, from, next) => {
  NProgress.start();

  const hasToken = getToken();
  if (to.path === "/login") {
    localStorage.setItem("YSY-ROUTER-fullPath", from.fullPath);
  }
  if (to.path === "/") {
    next({ path: "/index" });
    NProgress.done();
  } else {
    if (hasToken) {
      if (authUseList.includes(to.path)) {
        // 要访问授权相关路由时, 如果已经登录, 就重定向到首页
        if (
          from.path === "/user/accountManage" &&
          to.path === "/findbackstep"
        ) {
          next();
        } else {
          next({ path: "/index" });
          NProgress.done();
        }
      } else {
        next();
      }
    } else {
      // 若尚未登录, 判断要访问的路由是否在开放路由白名单中, 是则继续访问，否则重定向到登录页
      if (whiteList.includes(to.path)) {
        next();
      } else {
        next(`/login?redirect=${to.fullPath}`);
        NProgress.done();
      }
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
